




import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { DialogProgrammatic as Dialog } from "buefy";
import {
  VoteDocument,
  JinroPlayerDocument,
  JinroRoomDocument,
  JinroGamePlayinfoDocument
} from "../../../services/datatypes";
import { getVoteRankingTopList, getVoteResult } from "@/utils/utils";
import { JinroPlayStatus } from "../../../services/jinro-play-status";

@Component({
  components: {}
})
export default class Vote extends Vue {
  @Prop() readonly votes!: Array<VoteDocument>;
  @Prop() readonly survivors!: Array<JinroPlayerDocument>;

  @Watch("votedNumber")
  onChange() {
    if (this.survivors.length === this.votedNumber && this.isOwner) {
      this.ownerNotificationDialogue();
    }
  }
  ownerNotificationDialogue() {
    Dialog.confirm({
      message: this.message,
      canCancel: false,
      confirmText: "OK"
    });
  }

  get message(): string {
    let msg = "全員の投票が完了しました。<br/><br/>";
    const topVotedObject = getVoteRankingTopList(this.votes, 1)[0];
    console.log(topVotedObject);
    msg += `<strong>最多投票 ${topVotedObject.count}票 ${topVotedObject.playerNames.length}名</strong><br/>`;
    msg += topVotedObject.playerNames
      .map(name => {
        return `- ${name}<br/>`;
      })
      .join(" ");
    msg += "<br/>";
    msg += getVoteResult(this.votes, this.jinroGamePlayinfo);
    msg +=
      "<br/><br/>問題なければゲームマスターとして次に進めるため、「次に進める」ボタンをおしてください。";
    msg +=
      '<br/><span class="note">投票先が間違っているプレイヤーがいる場合は、そのプレイヤーに対して投票取り消しと再投票を案内ください。</span>';

    return msg;
  }

  get jinroGamePlayinfo(): JinroGamePlayinfoDocument | undefined {
    if (!this.$store.state.jinroGamePlayinfo) {
      return undefined;
    }
    return this.$store.state.jinroGamePlayinfo;
  }

  get jinroRoom(): JinroRoomDocument | undefined {
    if (!this.$store.state.jinroRoom) {
      return undefined;
    }
    return this.$store.state.jinroRoom;
  }

  get isOwner() {
    if (!this.jinroRoom) {
      return false;
    }
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom.owner === this.$store.state.firebaseUser.uid
    );
  }

  get votedNumber(): number {
    return this.votes.length;
  }
}
